import { render, staticRenderFns } from "./BoletinPeriodoEmiliani.vue?vue&type=template&id=6e36a452&scoped=true&"
import script from "./BoletinPeriodoEmiliani.vue?vue&type=script&lang=js&"
export * from "./BoletinPeriodoEmiliani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e36a452",
  null
  
)

export default component.exports